import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation ($email: String!, $password: String!) {
    customerLogin(options: { email: $email, password: $password }) {
      errors {
        message
      }
      token
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation (
    $password: String!
    $confirmPassword: String!
    $resetToken: String!
  ) {
    resetCustomerPassword(
      options: {
        password: $password
        confirmPassword: $confirmPassword
        resetToken: $resetToken
      }
    ) {
      token
      errors {
        message
      }
    }
  }
`;

export const SET_PASSWORD_MUTATION = gql`
  mutation (
    $password: String!
    $confirmPassword: String!
    $resetToken: String!
    $acceptedTerms: Boolean
  ) {
    completeCustomerRegistration(
      options: {
        password: $password
        confirmPassword: $confirmPassword
        resetToken: $resetToken
        acceptedTerms: $acceptedTerms
      }
    ) {
      token
      errors {
        message
      }
    }
  }
`;

export const COMPLETE_REGISTRATION_MUTATION = gql`
  mutation ($token: String!) {
    verifyToken(token: $token) {
      errors {
        message
      }
      message
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ($email: String!) {
    forgotCustomerPassword(email: $email) {
      message
      errors {
        message
      }
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation (
    $token: String!
    $agency: AgencyInputFields
    $customer: CustomerRegistration!
  ) {
    registerNewAgency(
      options: { token: $token, agency: $agency, customer: $customer }
    ) {
      client {
        id
        firstName
      }
      errors {
        message
      }
    }
  }
`;
